import axios from "axios";
import { getAccessToken } from "../apis/authToken";

const API_URL = process.env.REACT_APP_NOTIFICATION_SERVICE_URL;

export const getUserSubscriptions = async (userId, companyIdsString) => {
  try {
    const jwtToken = await getAccessToken();

    const response = await axios.post(
      `${API_URL}/filter`,
      {
        UserId: userId,
        CompanyIdsString: companyIdsString,
      },
      {
        headers: {
          Authorization: jwtToken,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      try {
        const accessToken = await getAccessToken();
        const retryResponse = await axios.post(
          `${API_URL}/filter`,
          {
            UserId: userId,
            CompanyIdsString: companyIdsString,
          },
          {
            headers: {
              Authorization: accessToken,
            },
          }
        );
        return retryResponse.data;
      } catch (retryError) {
        console.error("Retry with access token failed:", retryError);
      }
    }
    console.error("Error fetching subscriptions:", error);
    return [];
  }
};

export const updateUserSubscription = async (userId, changesList) => {
  const userSubscriptionsRequestModel = changesList.map((s) => ({
    SubscriptionId: s.Id,
    IsSubscribed: s.IsSubscribed,
  }));
  try {
    if (!Array.isArray(changesList) || changesList.length === 0) {
      throw new Error("Invalid changes list");
    }
    const jwtToken = await getAccessToken();

    const response = await axios.put(
      `${API_URL}/${userId}`,
      userSubscriptionsRequestModel,
      {
        headers: {
          Authorization: jwtToken,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      const accessToken = await getAccessToken();
      try {
        const retryResponse = await axios.put(
          `${API_URL}/${userId}`,
          userSubscriptionsRequestModel,
          {
            headers: {
              Authorization: accessToken,
            },
          }
        );
        return retryResponse.data;
      } catch (retryError) {
        console.error("Retry with access token failed:", retryError);
      }
    }
    console.error("Error updating user subscription:", error);
    throw error;
  }
};
